import { render, staticRenderFns } from "./scienceActive.vue?vue&type=template&id=8eab4be4&scoped=true"
import script from "./scienceActive.vue?vue&type=script&lang=js"
export * from "./scienceActive.vue?vue&type=script&lang=js"
import style0 from "./scienceActive.vue?vue&type=style&index=0&id=8eab4be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eab4be4",
  null
  
)

export default component.exports